import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, CardBody, Form, FormGroup, Label, Input, Button } from 'reactstrap'
import { getIdData, addData, updateData } from '../../lib/studentlessons'
import { LessonTypeSelect } from '../Common/FormSelects'

const LessonEditForGrade = ({ studentId, status, studentClass }) => {
	const [lessonType, setLessonType] = useState(null)
	const [lessonName, setLessonName] = useState('')
	const [isActive, setIsActive] = useState(true)
	const [loading, setLoading] = useState(false)

	const navigate = useNavigate()

	async function getData() {
		try {
			setLoading(true)
			const lessonNameData = await getIdData(status)
			if (lessonNameData && lessonNameData.length > 0) {
				setLessonName(lessonNameData[0].lessonName)
				setIsActive(lessonNameData[0].isActive)
				setLessonType(lessonNameData[0].lessonType)
			}
		} catch (error) {
			console.error('Error fetching lesson data:', error)
		} finally {
			setLoading(false)
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)

		try {
			if (status === 'Add') {
				await addData({
					class: studentClass,
					lessonName: lessonName,
					isActive: isActive,
					studentId: studentId,
					lessonType: lessonType
				})
			} else {
				await updateData({
					id: status,
					lessonName: lessonName,
					isActive: isActive,
					lessonType: lessonType
				})
			}

			navigate(-1)
		} catch (error) {
			console.error('Error saving lesson:', error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (status !== 'Add') {
			getData()
		}
	}, [status])

	return (
		<Card className="mb-4 shadow-sm">
			<div className="card-header bg-white border-bottom">
				<h5 className="mb-0 text-dark">{status === 'Add' ? 'Add New Course' : 'Update Course'}</h5>
			</div>
			<CardBody>
				{loading && status !== 'Add' ? (
					<div className="text-center p-4">
						<div className="spinner-border" role="status">
							<span className="visually-hidden">Loading...</span>
						</div>
						<p className="mt-2">Loading course data...</p>
					</div>
				) : (
					<Form onSubmit={handleSubmit}>
						<div className="row">
							<div className="col-lg-9 col-md-12">
								<FormGroup className="mb-3">
									<Label className="form-control-label fw-bold">Department</Label>
									<LessonTypeSelect value={lessonType} setValue={setLessonType} />
								</FormGroup>

								<FormGroup className="mb-3">
									<Label className="form-control-label fw-bold">Course Name</Label>
									<Input
										type="text"
										value={lessonName}
										onChange={(e) => setLessonName(e.target.value)}
										className="form-control"
										placeholder="Enter Course Name"
										required
									/>
								</FormGroup>

								<FormGroup className="mb-3">
									<Label className="form-control-label fw-bold">Is Active</Label>
									<div className="form-check form-switch">
										<Input
											className="form-check-input"
											type="checkbox"
											checked={isActive}
											onChange={(e) => setIsActive(e.target.checked)}
											style={{ cursor: 'pointer' }}
										/>
										<Label className="form-check-label ms-2">{isActive ? 'Active' : 'Inactive'}</Label>
									</div>
								</FormGroup>

								<div className="d-flex justify-content-between gap-2">
									<Button type="submit" color="primary" disabled={loading}>
										<i className="fa fa-save me-2"></i>
										{loading ? 'Saving...' : status === 'Add' ? 'Add Course' : 'Update Course'}
									</Button>
									<Button type="button" color="secondary" onClick={() => navigate(-1)}>
										<i className="fa fa-times me-2"></i>
										Cancel
									</Button>
								</div>
							</div>
						</div>
					</Form>
				)}
			</CardBody>
		</Card>
	)
}

export { LessonEditForGrade }
